const API_USERS_ROUTES = {
  path: '/api-users',
  component: () => import('@/pages/ApiUsers/ApiUsersPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'api-users.index',
      component: () => import('@/pages/ApiUsers/ApiUsersPage.vue'),
    },
    {
      path: 'create',
      name: 'api-users.create',
      component: () => import('@/pages/ApiUsers/ApiUsersFormPage.vue'),
    },
    {
      path: ':id/edit',
      name: 'api-users.edit',
      component: () => import('@/pages/ApiUsers/ApiUsersFormPage.vue'),
    },
  ],
};

export default API_USERS_ROUTES;
